<div class="select-role-component">
    @switch (readonlyModeOnSelection && !!role) {
        @case (true) {
            <adapt-link-role [role]="role"></adapt-link-role>
        }
        @default {
            <dx-select-box [showClearButton]="!required"
                           [dataSource]="dataSource"
                           [grouped]="true"
                           [isValid]="!required || !!role"
                           [(value)]="role"
                           (valueChange)="roleChange.emit($event)"
                           [searchEnabled]="true"
                           displayExpr="label">
                <div *dxTemplate="let item of 'item'">
                    {{ item.label }}
                </div>
            </dx-select-box>
        }
    }
</div>
